<template lang="">
  <div class="">
    <!-- 公共位置 -->
    <PositionGuid :posGuids="posGuids"></PositionGuid>
    <!-- 公共位置结束 -->
    <div class="lists2 gWidth  padding bg-white" v-cloak>
      <div class=" padding-bottom">
        <span class="mon_tit">高新区财政（务）预决算</span>
        <div class="news_r_b mon_bor" style="padding-bottom: 0;">
          <ul>
            <li
              class="flex flex-between "
              v-for="item in bdgxqys"
              :key="item.id"
            >
              <router-link
                :to="`/Dxarticles/${item.id}`"
                class="news_info"
                style="width: 52%;"
                >{{ item.title }}</router-link
              >
              <span class="news_data">{{ item.created_at }}</span>
            </li>
          </ul>
        </div>
      </div>

      <!-- 下边部分 -->
      <div class=" padding-bottom" style="margin-top: 1.25rem;">
        <span class="mon_tit">部门财政（务）预决算</span>
        <!-- <span class="mon_tit" >部门名称</span> -->
        <div
          class="news_r_b mon_bor"
          style="padding: 0;border-right: none;border-bottom: none;"
        >
          <ul style="display: flex;flex-wrap: wrap;">
            <li
              class="flex flex-between paddings"
              style="width: 50%;border-bottom: 1px solid #eae8e8;border-right: 1px solid #eae8e8;
							margin-bottom: 0;justify-content: center;font-weight: bold;"
            >
              部门名称
            </li>
            <li
              class="flex flex-between paddings"
              style="width: 50%;border-bottom: 1px solid #eae8e8;border-right: 1px solid #eae8e8;
							margin-bottom: 0;justify-content: center;font-weight: bold;"
            >
              部门名称
            </li>
            <li
              class="flex flex-between paddings"
              v-for="item in yjs"
              :key="item.id"
              style="width: 50%;border-bottom: 1px solid #eae8e8;border-right: 1px solid #eae8e8;
							margin-bottom: 0;"
            >
              <router-link
                :to="`/MonListIn/${item.id}`"
                class="news_info"
                style="width: 100%;"
                >{{ item.name }}</router-link
              >
              <!-- <a :href="'mon_list_in.html?id='+item.id" target="_blank" class="news_info" style="width: 100%;">{{item.name}}</a> -->
            </li>
          </ul>
        </div>
      </div>
      <!-- 下边部分--end -->
    </div>
  </div>
</template>
<script>
import { get_juesuan } from "@/api/gxq";
import PositionGuid from "../../components/PositionGuid/PositionGuid";
export default {
  name: "MonList",
  components: {
    PositionGuid,
  },
  data() {
    return {
      posGuids: [
        {
          title: "财政预决算专题 &gt; 列表",
          link: "",
        },
      ],
      zcjdList: [],
      currentPage: 1,
      totlePage: 45,
      liebiaos: [],
      id: "",
      isLoading: false,
      // 新的
      bdgxqys: [],
      yjs: [],
      // 新的end
    };
  },
  mounted() {
    this.get_juesuan2();
  },
  methods: {
    async get_juesuan2() {
      const { data } = await get_juesuan();
      this.bdgxqys = data.bdgxqys;
      this.yjs = data.yjs;
    },
  },
};
</script>
<style src="../../../vab/styles/gaikuang/gaikuang_big.css" scoped></style>
<style src="../../../vab/styles/gaikuang/gaikuang_mid.css" scoped></style>
<style src="../../../vab/styles/gaikuang/gaikuang_small.css" scoped></style>
<style src="../../../vab/styles/mon_list.css" scoped></style>
